import { usePlatformStore } from "@platform/store";

export const useUserFullname = () => {
  const user = usePlatformStore((s) => s.user);
  return [user?.first_name, user?.last_name].filter(Boolean).join(" ");
};

export default useUserFullname;
